import axios from 'axios';
import {
  GetOneSmartInterviewOutput,
  SmartInterviewsBuilder,
  UpdateSmartInterviewInput,
} from '../smart-interviews.types';

export const updateSmartInterview = (builder: SmartInterviewsBuilder) =>
  builder.mutation<GetOneSmartInterviewOutput, UpdateSmartInterviewInput>({
    queryFn: async ({ smartInterviewId, data, disableUpdateVoice = false }) => {
      const updateOneSmartInterview =
        await axios.put<GetOneSmartInterviewOutput>(
          `${import.meta.env.REACT_APP_API_URL}/smart-interview-questions/${smartInterviewId}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('id_token')}`,
            },
          }
        );

      if (updateOneSmartInterview.data) {
        if (!disableUpdateVoice)
          await axios.post(
            `${import.meta.env.REACT_APP_API_URL}/smart-interview-questions/${smartInterviewId}/generate-voice
`,
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('id_token')}`,
              },
            }
          );

        return { ...updateOneSmartInterview };
      }

      return { error: { ...updateOneSmartInterview } };
    },
  });
